import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-previred',
  templateUrl: './main-previred.component.html',
  styleUrls: ['./main-previred.component.css']
})
export class MainPreviredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
